// Mock data for Lemoncaps Products and Tech Solutions Pvt Ltd
// NOTE: All data here is MOCKED for the frontend-only preview.

export const company = {
  name: "Lemoncaps",
  fullName: "Lemoncaps Products and Tech Solutions Pvt Ltd",
  tagline: "Products & Tech Solutions",
  role1: "Product",
  role2: "Engineering",
  year: "2026",
  email: "hello@lemoncaps.com",
  phone: "+91 98765 43210",
  location: "India",
  intro:
    "We design and engineer custom software \u2014 websites, mobile apps, and CRMs \u2014 that turn complex business requirements into seamless digital experiences. We partner with founders and teams who need builders that actually understand product.",
};

export const stats = [
  { value: "120+", label: "Projects Shipped" },
  { value: "45+", label: "Happy Clients" },
  { value: "8", label: "Years Building" },
  { value: "14", label: "Team Engineers" },
];

export const helpBlocks = [
  {
    title: "Strategy & Build",
    body:
      "We build custom software meant to do something useful for your business, not just look impressive. That means fast performance, solid architecture, and a codebase that scales as you grow. We mainly work with React, Next.js and modern cloud stacks.",
  },
  {
    title: "Design and Development, Together",
    body:
      "A lot of projects slow down when design and development are handled separately. Because our product designers and engineers work as one team, the handoff disappears and the result stays consistent from first concept to launch.",
  },
  {
    title: "Performance Without the Bloat",
    body:
      "We don't ship generic templates or unnecessary code. Every build is custom, with performance and usability considered from the start. When a project calls for it, we integrate real-time data, AI and 3D experiences the right way.",
  },
];

export const services = [
  {
    id: "web",
    index: "01",
    title: "Websites & Web Platforms",
    desc:
      "High-performance marketing sites, dashboards and full web platforms built with React & Next.js.",
    tags: ["Next.js", "React", "WebGL", "SEO"],
  },
  {
    id: "mobile",
    index: "02",
    title: "Mobile Applications",
    desc:
      "Native-feeling iOS & Android apps from a single codebase, with offline-first architecture.",
    tags: ["React Native", "Flutter", "iOS", "Android"],
  },
  {
    id: "crm",
    index: "03",
    title: "CRM & Business Systems",
    desc:
      "Custom CRMs, ERPs and internal tools that automate your operations end to end.",
    tags: ["Automation", "Dashboards", "Integrations"],
  },
  {
    id: "products",
    index: "04",
    title: "SaaS Products",
    desc:
      "From idea to launch \u2014 we help founders build, ship and scale their software products.",
    tags: ["MVP", "Cloud", "AI", "Scale"],
  },
];

export const work = [
  { id: "finflow", title: "FinFlow", cat: "Fintech CRM, Web Development", color: "#d4ff4e", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "medico", title: "Medico", cat: "Healthcare, Mobile App", color: "#7ee7ff", img: "https://images.unsplash.com/photo-1480694313141-fce5e697ee25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "cartly", title: "Cartly", cat: "E-commerce, Web Platform", color: "#ff9d6c", img: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "fleetos", title: "FleetOS", cat: "Logistics CRM, Dashboard", color: "#c9a6ff", img: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "eduspark", title: "EduSpark", cat: "EdTech, Web & Mobile", color: "#ff7eb6", img: "https://images.pexels.com/photos/27141307/pexels-photo-27141307.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "agrigrid", title: "AgriGrid", cat: "SaaS Product, AI", color: "#8affc1", img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const testimonials = [
  {
    quote:
      "Lemoncaps rebuilt our entire CRM in weeks. The team thinks like product owners, not just coders.",
    author: "Ananya Rao",
    title: "COO, FinFlow",
  },
  {
    quote:
      "The mobile app they shipped feels premium. Our retention jumped 30% in the first quarter.",
    author: "Rahul Menon",
    title: "Founder, Medico",
  },
];

export const socials = [
  { label: "LinkedIn", href: "#" },
  { label: "GitHub", href: "#" },
  { label: "Instagram", href: "#" },
  { label: "X", href: "#" },
  { label: "WhatsApp", href: "#" },
];

export const nav = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "work", label: "Work" },
  { id: "contact", label: "Contact" },
];
